<template>
    <div class="col-md-12">
        <div class="col-md-10 col-md-offset-1">
            <h2 class="title">Enregister un son</h2>
            <record @sendSuccess="onSendSuccess()" @sendFail="onSendFail()" @convertFail="onConvertFail()"></record>
        </div>
    </div>
</template>

<script>
    import Record from 'components/Record'

    export default {
        components: {
            Record
        },
        methods:    {
            onSendSuccess()  {
                this.$store.commit('ALERT_DATA_UPDATED', {
                        text: "Le son a été envoyé avec succès.",
                        type: 'success'
                });
            },
            onSendFail()  {
                this.$store.commit('ALERT_DATA_UPDATED', {
                        text: "L'envoi du son a échoué.",
                        type: 'danger'
                });
            },
            onConvertFail() {
                this.$store.commit('ALERT_DATA_UPDATED', {
                        text: "La conversion du son a échoué.",
                        type: 'danger'
                });
            }
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour',
                pathData: null
            });
        }
    };
</script>

<style scoped>
.title  {
    text-align:center;
    margin-bottom:2em;
}
</style>